import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { Layer } from 'bernie-view';
import { LocalizedComponentProps, LocalizedText } from 'bernie-l10n';
import { QueryRoute, RouteStore } from 'bernie-core';

import { SearchResultsStore } from 'stores/search-results-store';

import { UitkCardAloha, UitkCardAlohaContentSection, UitkCardAlohaLink } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkLink, UitkLinkAlign } from 'uitk-react-link';
import { UitkSecondaryButton } from 'uitk-react-button';

import { SearchResultsMap } from 'components/search/map';

const LinkTracked = ClickTracker(Link);
const ButtonTracked = ClickTracker(UitkSecondaryButton);

export interface MapToggleProps extends LocalizedComponentProps {
  className?: string;
  routeStore?: RouteStore;
  searchResults?: SearchResultsStore;
  mapImage?: string;
  isActive: boolean;
}

@inject('searchResults', 'routeStore')
@observer
export class MapToggle extends React.Component<MapToggleProps> {
  private mapBtn;

  constructor(props) {
    super(props);

    this.onMapDialogClosed = this.onMapDialogClosed.bind(this);
    this.mapBtn = React.createRef();
  }

  public static defaultProps = {
    isActive: false,
  };

  public render() {
    const { isActive, searchResults, routeStore, mapImage } = this.props;
    const { isLoading, isError, isEmpty } = searchResults;
    const map = searchResults && searchResults.map;
    const mapOpenQuery = routeStore.mergeQueryString(routeStore.search, { pwaOverlay: 'map' });
    const linkTo = {
      pathname: routeStore.pathname,
      search: mapOpenQuery,
    };
    const extraProps =
      isActive && map && Object.keys(map).length > 0
        ? {
            tag: Link,
            to: linkTo,
            role: 'button',
          }
        : {};

    const triggerRef = mapBtn => {
      this.mapBtn = mapBtn;
    };

    return (
      <>
        <QueryRoute query={{ pwaOverlay: 'map' }}>
          <Layer id="tools-map">
            <SearchResultsMap onDismiss={this.onMapDialogClosed} />
          </Layer>
        </QueryRoute>
        {mapImage && (
          <UitkCardAloha>
            <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
              <UitkImage alt="" src={mapImage} />
            </UitkFigure>
            <UitkCardAlohaContentSection>
              <UitkLink inline={true} align={UitkLinkAlign.CENTER}>
                <div aria-hidden="true">
                  <LocalizedText message="hotels.searchResults.openMapDialog.label" />
                </div>
              </UitkLink>
            </UitkCardAlohaContentSection>
            <UitkCardAlohaLink>
              <LinkTracked linkName="Launch dynamic map" rfrr="Module.MapOpen.Link" to={linkTo} innerRef={triggerRef}>
                <LocalizedText message="hotels.searchResults.openMapDialog.label" />
              </LinkTracked>
            </UitkCardAlohaLink>
          </UitkCardAloha>
        )}
        {!mapImage && (
          <ButtonTracked
            data-stid="open-dynamic-map"
            disabled={!isActive || isLoading || isError || isEmpty || null}
            linkName="Launch dynamic map"
            rfrr="Module.MapOpen.Link"
            icon="map"
            text={<LocalizedText message="hotels.searchResults.openMapDialog.label" />}
            isFullWidth={true}
            {...extraProps}
          />
        )}
      </>
    );
  }

  private onMapDialogClosed(): void {
    this.props.routeStore.updateSearch({
      pwaOverlay: undefined,
    });

    if (this.mapBtn && typeof this.mapBtn.focus === 'function') {
      this.mapBtn.focus();
    }
  }
}
